import { useNavigate } from "react-router-dom";
import "../../styles/common/notFound.css";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="not-found">
      <div className="not-found-code">404</div>
      <h1 className="not-found-title">Page not found</h1>
      <p className="not-found-desc">
        The page you're looking for doesn't exist or has been moved.
      </p>
      <div className="not-found-actions">
        <button className="not-found-btn primary" onClick={() => navigate("/")}>
          Go Home
        </button>
        <button className="not-found-btn" onClick={() => navigate(-1)}>
          Go Back
        </button>
      </div>
    </div>
  );
};

export default NotFound;
